/* Golazo — theme.js */

(function () {
  'use strict';

  // ---------- Scroll-triggered reveals (data-reveal + data-img-zoom) ----------
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var revealObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          revealObs.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    function watchReveals() {
      document.querySelectorAll('[data-reveal]:not(.is-revealed), [data-img-zoom]:not(.is-revealed)').forEach(function (el) {
        revealObs.observe(el);
      });
    }
    watchReveals();
    document.addEventListener('shopify:section:load', watchReveals);
    // Safety: anything still hidden 1.5s after load (e.g., already in viewport
    // but IO missed) gets revealed. On mobile Safari, IO occasionally misses
    // fires entirely — section-header / titles must NEVER stay invisible.
    setTimeout(function () {
      document.querySelectorAll('[data-reveal]:not(.is-revealed), [data-img-zoom]:not(.is-revealed)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-revealed');
      });
      // Section headers always reveal — their content (titles) must always paint.
      document.querySelectorAll('.section-header[data-reveal]:not(.is-revealed)').forEach(function (el) {
        el.classList.add('is-revealed');
      });
    }, 1500);
  } else {
    document.querySelectorAll('[data-reveal], [data-img-zoom]').forEach(function (el) { el.classList.add('is-revealed'); });
  }

  // ---------- Product card scroll-triggered typography reveal ----------
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var cardObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in-view');
          cardObs.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    function watchCards() {
      document.querySelectorAll('.product-card:not(.is-in-view)').forEach(function (c) { cardObs.observe(c); });
    }
    watchCards();
    document.addEventListener('shopify:section:load', watchCards);
    // Re-scan after AJAX filters / recommendations replace DOM
    var mo;
    try {
      mo = new MutationObserver(watchCards);
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
    // Safety: any card visible in the viewport after 1.5s gets revealed (covers theme editor preview)
    setTimeout(function () {
      document.querySelectorAll('.product-card:not(.is-in-view)').forEach(function (c) {
        var r = c.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) c.classList.add('is-in-view');
      });
    }, 1500);
  } else {
    document.querySelectorAll('.product-card').forEach(function (c) { c.classList.add('is-in-view'); });
  }

  // ---------- Split-text reveal: per-character lift on scroll ----------
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    /* Gradient-clipped titles (.section-header__title, .bento__title, .product-card__title,
       .product__title) are EXCLUDED — per-char splitting + transform animations
       break iOS Safari background-clip:text paint and the titles vanish. */
    var SPLIT_SELECTOR = [
      '.bento__eyebrow',
      '.faq__q > span',
      '.stats-band__label',
      '.image-text h2', '.image-text h3',
      '.testimonial-title',
      '.hero__eyebrow',
      '.hero__subtitle',
      '.eyebrow',
      '[data-split-text]'
    ].join(',');

    function splitElement(el) {
      if (el.dataset.splitDone) return;
      var text = (el.textContent || '').trim();
      if (!text || text.length > 140) { el.dataset.splitDone = '1'; return; }
      // Skip if any child element exists (rich text — don't mangle)
      if (el.children.length > 0) { el.dataset.splitDone = '1'; return; }
      var chars = Array.from(text);
      var idx = 0;
      var html = '';
      for (var i = 0; i < chars.length; i++) {
        var c = chars[i];
        if (c === ' ') { html += '<span class="split-space"> </span>'; continue; }
        html += '<span class="split-char" style="--i:' + idx + '">' + (c === '<' ? '&lt;' : c === '>' ? '&gt;' : c === '&' ? '&amp;' : c) + '</span>';
        idx++;
      }
      el.innerHTML = html;
      el.classList.add('has-split');
      el.dataset.splitDone = '1';
    }

    function scanSplits() {
      document.querySelectorAll(SPLIT_SELECTOR).forEach(splitElement);
    }
    scanSplits();
    document.addEventListener('shopify:section:load', scanSplits);

    // When the parent reveal root scrolls in, the .is-revealed cascade triggers chars (CSS-only).
    // For split elements whose ancestor never gets .is-revealed (e.g., orphaned), observe them directly.
    var splitObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          splitObs.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.1 });
    function watchSplits() {
      document.querySelectorAll('.has-split:not(.is-revealed)').forEach(function (el) {
        splitObs.observe(el);
      });
    }
    watchSplits();
    document.addEventListener('shopify:section:load', watchSplits);
    // Safety net: anything already on-screen at load
    setTimeout(function () {
      document.querySelectorAll('.has-split:not(.is-revealed)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-revealed');
      });
    }, 1500);
  }

  // ---------- Card touch (mobile hover equivalent) for product + bento cards ----------
  // First tap previews; second tap navigates.
  (function cardTouch() {
    if (!window.matchMedia('(hover: none)').matches) return;
    document.addEventListener('click', function (e) {
      // Always allow quick-view button click
      if (e.target.closest('[data-quick-view]')) {
        document.querySelectorAll('.product-card.is-touched, .bento__card.is-touched').forEach(function (c) { c.classList.remove('is-touched'); });
        return;
      }
      var card = e.target.closest('.product-card, .bento__card');
      // Clear other previewing cards
      document.querySelectorAll('.product-card.is-touched, .bento__card.is-touched').forEach(function (c) {
        if (c !== card) c.classList.remove('is-touched');
      });
      if (!card) return;
      if (!card.classList.contains('is-touched')) {
        e.preventDefault();
        e.stopPropagation();
        card.classList.add('is-touched');
      }
      // else: second tap on same card — let the link navigate
    }, true);
  })();

  // ---------- Section-header decoration variants (line / circles / zigzag / dots) ----------
  (function decoVariants() {
    var variants = ['line', 'circles', 'zigzag', 'dots'];
    function tag() {
      var headers = document.querySelectorAll('.section-header:not([data-deco])');
      headers.forEach(function (h, i) {
        h.setAttribute('data-deco', variants[i % variants.length]);
      });
    }
    tag();
    document.addEventListener('shopify:section:load', tag);
  })();

  // ---------- Animated number counters ----------
  function animateCount(el) {
    var raw = el.getAttribute('data-count') || el.textContent;
    var num = parseFloat(String(raw).replace(/[^\d.]/g, ''));
    if (!isFinite(num)) return;
    var prefix = '';
    var suffix = '';
    var match = String(raw).match(/^(\D*)([\d.,]+)(\D*)$/);
    if (match) { prefix = match[1]; suffix = match[3]; }
    var decimals = (String(num).split('.')[1] || '').length;
    var dur = 1400;
    var start = null;
    function step(t) {
      if (!start) start = t;
      var p = Math.min(1, (t - start) / dur);
      var eased = 1 - Math.pow(1 - p, 3);
      var val = (num * eased).toFixed(decimals);
      el.textContent = prefix + val + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  if ('IntersectionObserver' in window) {
    var countObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateCount(entry.target);
          countObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });
    document.querySelectorAll('[data-count]').forEach(function (el) { countObs.observe(el); });
  }

  // ---------- Generic modal open/close ----------
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-open-modal]');
    if (trigger) {
      e.preventDefault();
      var id = trigger.getAttribute('data-open-modal');
      var modal = document.getElementById(id);
      if (!modal) return;
      modal.setAttribute('aria-hidden', 'false');
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      return;
    }
    var modalClose = e.target.closest('[data-modal] [data-close]');
    if (modalClose) {
      var openModal = modalClose.closest('[data-modal]');
      if (openModal) {
        openModal.classList.remove('is-open');
        openModal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-modal].is-open').forEach(function (m) {
      m.classList.remove('is-open');
      m.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    });
  });

  // Size-guide tabs
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('.size-modal__tab');
    if (!tab) return;
    var modal = tab.closest('[data-modal]');
    if (!modal) return;
    var name = tab.getAttribute('data-tab');
    modal.querySelectorAll('.size-modal__tab').forEach(function (t) {
      var active = t.getAttribute('data-tab') === name;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    modal.querySelectorAll('.size-modal__table').forEach(function (tbl) {
      tbl.classList.toggle('is-active', tbl.getAttribute('data-tab-panel') === name);
    });
  });

  // ---------- Quick View ----------
  function moneyFmtSimple(cents) {
    var sym = (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active + ' ' : '';
    return sym + (cents / 100).toFixed(2);
  }
  function escHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
      return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[m];
    });
  }
  function openQuickView(handle) {
    var modal = document.getElementById('QuickView');
    if (!modal) return;
    var body = modal.querySelector('[data-qv-body]');
    body.innerHTML = '<div class="quick-view__loading"><span class="quick-view__spinner"></span></div>';
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var imgs = p.images || [];
        var galleryHTML = '<div class="qv-gallery">' +
          '<div class="qv-stage">' +
            imgs.map(function (src, i) {
              return '<figure class="qv-slide' + (i === 0 ? ' is-active' : '') + '" data-qv-slide="' + i + '"><img src="' + src + '" alt=""></figure>';
            }).join('') +
          '</div>' +
          (imgs.length > 1 ? '<div class="qv-thumbs">' + imgs.map(function (src, i) {
            return '<button type="button" class="qv-thumb' + (i === 0 ? ' is-active' : '') + '" data-qv-thumb="' + i + '" aria-label="Image ' + (i+1) + '"><img src="' + src + '" alt=""></button>';
          }).join('') + '</div>' : '') +
        '</div>';

        var saleHTML = '';
        if (p.compare_at_price > p.price) {
          saleHTML = '<span class="qv-price-compare">' + moneyFmtSimple(p.compare_at_price) + '</span>';
        }

        var optionsHTML = (p.options || []).map(function (opt, i) {
          var values = (opt.values || []).map(function (v) {
            return '<button type="button" class="qv-opt" data-qv-opt-group="' + i + '" data-qv-opt="' + escHtml(v) + '">' + escHtml(v) + '</button>';
          }).join('');
          return '<div class="qv-option"><label>' + escHtml(opt.name || opt) + '</label><div class="qv-opt-row">' + values + '</div></div>';
        }).join('');

        body.innerHTML =
          '<div class="qv-grid">' +
            galleryHTML +
            '<div class="qv-info">' +
              '<h2 class="qv-title" id="QuickViewTitle">' + escHtml(p.title) + '</h2>' +
              '<p class="qv-price">' + saleHTML + '<span class="qv-price-current" data-qv-price>' + moneyFmtSimple(p.price) + '</span></p>' +
              (p.description ? '<div class="qv-desc">' + p.description + '</div>' : '') +
              (optionsHTML ? '<div class="qv-options">' + optionsHTML + '</div>' : '') +
              '<button type="button" class="btn btn--block btn--gold qv-atc" data-qv-atc>' +
                '<svg class="btn__icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true"><path d="M4 6h16l-1.5 12.5a1.5 1.5 0 0 1-1.5 1.3H7a1.5 1.5 0 0 1-1.5-1.3L4 6z"/><path d="M9 6V4a3 3 0 0 1 6 0v2"/></svg>' +
                '<span class="btn__label">' + (modal.getAttribute('data-i18n-add') || 'Add to cart') + ' — <span data-qv-add-price>' + moneyFmtSimple(p.price) + '</span></span>' +
                '<span class="btn__spinner" aria-hidden="true"></span>' +
              '</button>' +
              '<a href="/products/' + handle + '" class="btn btn--link qv-details">' + (modal.getAttribute('data-i18n-view-full') || 'View full details') + ' →</a>' +
            '</div>' +
          '</div>';

        // Wire up gallery + thumbs
        var thumbs = body.querySelectorAll('[data-qv-thumb]');
        thumbs.forEach(function (t) {
          t.addEventListener('click', function () {
            var idx = t.getAttribute('data-qv-thumb');
            body.querySelectorAll('[data-qv-slide]').forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-qv-slide') === idx); });
            thumbs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
          });
        });

        // Variant matching
        function normVal(s) { return String(s == null ? '' : s).normalize ? String(s).normalize('NFKC').replace(/\s+/g, ' ').trim().toLowerCase() : String(s || '').toLowerCase().trim(); }
        function getSelectedQv() {
          var vals = [];
          body.querySelectorAll('.qv-option').forEach(function (g) {
            var a = g.querySelector('.qv-opt.is-active');
            if (a) vals.push(a.getAttribute('data-qv-opt'));
          });
          return vals;
        }
        function findVariantQv(vals) {
          var n = vals.map(normVal);
          for (var i = 0; i < p.variants.length; i++) {
            var v = p.variants[i];
            var opts = [v.option1, v.option2, v.option3].filter(function (x) { return x != null; }).map(normVal);
            if (opts.length === n.length && opts.every(function (o, idx) { return o === n[idx]; })) return v;
          }
          return null;
        }
        function syncQv() {
          var v = findVariantQv(getSelectedQv());
          if (!v) return;
          var price = body.querySelector('[data-qv-price]');
          var addP = body.querySelector('[data-qv-add-price]');
          if (price) price.textContent = moneyFmtSimple(v.price);
          if (addP) addP.textContent = moneyFmtSimple(v.price);
          // Swap to variant's image if it has one
          if (v.featured_image && v.featured_image.id != null) {
            var idx = imgs.findIndex(function (src) {
              return src.indexOf('/' + v.featured_image.id + '?') !== -1 || src.indexOf('/' + v.featured_image.id + '.') !== -1;
            });
            if (idx >= 0) {
              body.querySelectorAll('[data-qv-slide]').forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-qv-slide') === String(idx)); });
              body.querySelectorAll('[data-qv-thumb]').forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-qv-thumb') === String(idx)); });
            }
          }
        }
        // Wire up option pills
        body.querySelectorAll('.qv-opt').forEach(function (b) {
          b.addEventListener('click', function () {
            var g = b.getAttribute('data-qv-opt-group');
            body.querySelectorAll('[data-qv-opt-group="' + g + '"]').forEach(function (x) { x.classList.remove('is-active'); });
            b.classList.add('is-active');
            syncQv();
          });
        });
        // Mark first option of each as active by default
        body.querySelectorAll('.qv-option').forEach(function (g) { var first = g.querySelector('.qv-opt'); if (first) first.classList.add('is-active'); });
        syncQv();

        // ATC handler
        var atcBtn = body.querySelector('[data-qv-atc]');
        if (atcBtn) {
          atcBtn.addEventListener('click', function () {
            var v = findVariantQv(getSelectedQv());
            if (!v) return;
            atcBtn.classList.add('is-loading');
            atcBtn.setAttribute('disabled', '');
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              credentials: 'same-origin',
              body: JSON.stringify({ id: v.id, quantity: 1 })
            })
              .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
              .then(function (res) {
                if (!res.ok) return;
                atcBtn.classList.add('is-added');
                setTimeout(function () { atcBtn.classList.remove('is-added'); }, 1600);
                refreshCart().then(function () {
                  modal.classList.remove('is-open');
                  modal.setAttribute('aria-hidden', 'true');
                  document.body.style.overflow = '';
                  var drawer = document.getElementById('CartDrawer');
                  if (drawer) setTimeout(function () { openPanel(drawer); }, 280);
                });
              })
              .finally(function () {
                atcBtn.classList.remove('is-loading');
                atcBtn.removeAttribute('disabled');
              });
          });
        }
      })
      .catch(function () {
        body.innerHTML = '<p style="padding:2rem;text-align:center;">Could not load this product. <a href="/products/' + handle + '">Open the product page →</a></p>';
      });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-view]');
    if (!btn) return;
    e.preventDefault();
    openQuickView(btn.getAttribute('data-product-handle'));
  });

  // ---------- Bulletproof variant pill toggle (capture phase, runs first) ----------
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-option-value]');
    if (!btn) return;
    var group = btn.closest('.product__variant-options');
    if (!group) return;
    group.querySelectorAll('[data-option-value]').forEach(function (b) {
      b.setAttribute('aria-checked', 'false');
      b.setAttribute('tabindex', '-1');
    });
    btn.setAttribute('aria-checked', 'true');
    btn.setAttribute('tabindex', '0');
  }, true);

  // ---------- Drawers / Panels (with focus trap + aria-hidden) ----------
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var lastTrigger = null;

  function openPanel(el, triggerEl) {
    el.setAttribute('open', '');
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    lastTrigger = triggerEl || document.activeElement;
    var first = el.querySelector(FOCUSABLE);
    if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 60);
  }
  function closePanel(el) {
    el.removeAttribute('open');
    el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      try { lastTrigger.focus({ preventScroll: true }); } catch (_) {}
      lastTrigger = null;
    }
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-toggle]');
    if (trigger) {
      var target = document.getElementById(trigger.getAttribute('data-target'));
      if (target) {
        if (target.hasAttribute('open')) closePanel(target); else openPanel(target, trigger);
      }
      return;
    }
    var closer = e.target.closest('[data-close]');
    if (closer) {
      var panel = closer.closest('[data-panel]');
      if (panel) closePanel(panel);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-panel][open]').forEach(closePanel);
      return;
    }
    if (e.key !== 'Tab') return;
    var open = document.querySelector('[data-panel][open]');
    if (!open) return;
    var focusables = Array.from(open.querySelectorAll(FOCUSABLE)).filter(function (n) { return n.offsetParent !== null; });
    if (!focusables.length) return;
    var first = focusables[0], last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // ---------- Auto-stagger: parent declares data-stagger="<ms>" ----------
  function applyStagger() {
    document.querySelectorAll('[data-stagger]').forEach(function (parent) {
      var step = parseInt(parent.getAttribute('data-stagger'), 10) || 80;
      parent.style.setProperty('--stagger-step', step + 'ms');
      Array.prototype.forEach.call(parent.children, function (child, i) {
        child.style.setProperty('--stagger-i', i);
      });
    });
  }
  applyStagger();
  document.addEventListener('shopify:section:load', applyStagger);

  // ---------- Word-reveal for headings tagged with data-word-reveal ----------
  function splitWords(el) {
    if (el.dataset.wordReady) return;
    var text = el.textContent.trim();
    el.innerHTML = '';
    var words = text.split(/\s+/);
    words.forEach(function (w, i) {
      var wrap = document.createElement('span');
      wrap.className = 'word-reveal';
      var inner = document.createElement('span');
      inner.className = 'word-reveal__word';
      inner.style.setProperty('--w', i);
      inner.textContent = w;
      wrap.appendChild(inner);
      el.appendChild(wrap);
      if (i < words.length - 1) el.appendChild(document.createTextNode(' '));
    });
    el.dataset.wordReady = '1';
  }
  document.querySelectorAll('[data-word-reveal]').forEach(splitWords);

  // ---------- Scroll reveal ----------
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if ('IntersectionObserver' in window && !prefersReduced) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px 0px 0px', threshold: 0.01 });

    function watch() {
      document.querySelectorAll('[data-reveal]:not(.is-visible), [data-img-zoom]:not(.is-visible)').forEach(function (el) { io.observe(el); });
    }
    watch();
    document.addEventListener('shopify:section:load', watch);

    // Safety net: anything still hidden after 1.5s gets revealed
    setTimeout(function () {
      document.querySelectorAll('[data-reveal]:not(.is-visible), [data-img-zoom]:not(.is-visible)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-visible');
      });
    }, 1500);
  } else {
    document.querySelectorAll('[data-reveal], [data-img-zoom]').forEach(function (el) { el.classList.add('is-visible'); });
  }

  // ---------- Trigger word reveal once loaded ----------
  function markLoaded() {
    document.documentElement.classList.add('is-loaded');
  }
  if (document.readyState === 'complete') markLoaded();
  else window.addEventListener('load', markLoaded);

  // ---------- Back to top ----------
  var btt = document.querySelector('[data-back-to-top]');
  if (btt) {
    var bttObs = function () { btt.classList.toggle('is-visible', window.scrollY > 600); };
    window.addEventListener('scroll', bttObs, { passive: true });
    bttObs();
    btt.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: prefersReduced ? 'auto' : 'smooth' });
    });
  }

  // ---------- Language switcher tap toggle ----------
  document.querySelectorAll('[data-lang-switch]').forEach(function (wrap) {
    var trigger = wrap.querySelector('[data-lang-trigger]');
    if (!trigger) return;
    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = wrap.getAttribute('aria-expanded') === 'true';
      wrap.setAttribute('aria-expanded', open ? 'false' : 'true');
      trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  });
  document.addEventListener('click', function (e) {
    document.querySelectorAll('[data-lang-switch][aria-expanded="true"]').forEach(function (w) {
      if (!w.contains(e.target)) { w.setAttribute('aria-expanded', 'false'); var t = w.querySelector('[data-lang-trigger]'); if (t) t.setAttribute('aria-expanded', 'false'); }
    });
  });

  // ---------- Parallax ----------
  if (!prefersReduced) {
    var parallaxEls = [];
    function registerParallax() {
      parallaxEls = Array.from(document.querySelectorAll('[data-parallax]'));
    }
    registerParallax();
    document.addEventListener('shopify:section:load', registerParallax);

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      window.requestAnimationFrame(function () {
        var vh = window.innerHeight;
        parallaxEls.forEach(function (el) {
          var rect = el.getBoundingClientRect();
          if (rect.bottom < 0 || rect.top > vh) return;
          var speed = parseFloat(el.getAttribute('data-parallax')) || 0.15;
          var offset = (rect.top - vh / 2) * speed * -1;
          el.style.setProperty('--py', offset.toFixed(1) + 'px');
        });
        ticking = false;
      });
      ticking = true;
    }, { passive: true });
  }

  // ---------- Marquee duplication ----------
  document.querySelectorAll('[data-marquee]').forEach(function (m) {
    var track = m.querySelector('[data-marquee-track]');
    if (!track || track.dataset.cloned) return;
    var clone = track.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    track.dataset.cloned = '1';
    m.appendChild(clone);
  });

  // ---------- AJAX cart ----------
  function cartCountEls() { return document.querySelectorAll('[data-cart-count]'); }
  function setLoading(on) { document.body.classList.toggle('cart-loading', on); }

  function cleanupOrphanAddons(cart) {
    if (!cart || !cart.items) return Promise.resolve(cart);
    var pairsWithParent = {};
    var parentVariantIds = {};
    cart.items.forEach(function (i) {
      var p = i.properties || {};
      if (!p._linked_for) {
        if (p._pair) pairsWithParent[p._pair] = true;
        parentVariantIds[String(i.variant_id)] = true;
      }
    });
    var orphans = cart.items.filter(function (i) {
      var p = i.properties || {};
      if (!p._linked_for) return false;
      // Modern addons: matched by _pair
      if (p._pair) return !pairsWithParent[p._pair];
      // Legacy addons: matched by variant_id stored in _linked_for
      return !parentVariantIds[String(p._linked_for)];
    }).map(function (i) { return i.key; });

    if (!orphans.length) return Promise.resolve(cart);
    var updates = {};
    orphans.forEach(function (k) { updates[k] = 0; });
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates })
    }).then(function (r) { return r.json(); });
  }

  // Remove just the personalization addon(s) from a line
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-remove-pers]');
    if (!btn) return;
    e.preventDefault();
    var keys = (btn.getAttribute('data-keys') || '').split(',').map(function (k) { return k.trim(); }).filter(Boolean);
    if (!keys.length) return;
    var updates = {};
    keys.forEach(function (k) { updates[k] = 0; });
    updateLines(updates);
  });

  function refreshCart() {
    setLoading(true);
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(cleanupOrphanAddons)
      .then(function (cart) {
        return Promise.all([
          Promise.resolve(cart),
          fetch('/?section_id=cart-drawer-fragment', { credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.text() : ''; })
            .catch(function () { return ''; })
        ]);
      })
      .then(function (results) {
        var cart = results[0];
        var html = results[1];

        cartCountEls().forEach(function (el) {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) { el.removeAttribute('hidden'); el.style.animation = 'none'; void el.offsetWidth; el.style.animation = ''; }
          else el.setAttribute('hidden', '');
        });

        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-body]');
          var current = document.querySelector('#CartDrawer [data-cart-body]');
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        }
      }).finally(function () { setLoading(false); });
  }

  // Clean any orphans left over from previous sessions on first load
  setTimeout(function () { refreshCart(); }, 600);

  // Quick-add from product card (single-variant products)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    btn.classList.add('is-loading');
    btn.setAttribute('disabled', '');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) { btn.classList.add('is-error'); setTimeout(function () { btn.classList.remove('is-error'); }, 2000); return; }
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 1600);
        refreshCart().then(function () {
          var drawer = document.getElementById('CartDrawer');
          if (drawer) openPanel(drawer, btn);
        });
      })
      .finally(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('disabled');
      });
  });

  // Add to cart (with optional personalization addon)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action$="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[data-add-to-cart], [type=submit]');
    if (btn) btn.classList.add('is-loading');
    if (btn) btn.setAttribute('disabled', '');

    // Build the main item from the form
    var fd = new FormData(form);
    var mainId = fd.get('id');
    var qty = parseInt(fd.get('quantity'), 10) || 1;
    var mainProps = {};
    fd.forEach(function (val, key) {
      var m = key.match(/^properties\[(.+)\]$/);
      if (m && val && String(val).length > 0) mainProps[m[1]] = String(val);
    });

    // Check for personalization addon
    var persWrap = form.querySelector('[data-personalize]');
    var persEl = persWrap ? persWrap.querySelector('[data-pers-input]') : null;
    var persVal = persEl ? (persEl.value || '').trim() : '';
    var addonId = persWrap ? persWrap.getAttribute('data-addon-id') : '';
    var productTitle = form.getAttribute('data-product-title') || '';
    var hasPersonalization = !!(persWrap && addonId && persVal);

    if (!hasPersonalization) { delete mainProps.Personalization; }
    var pairId = hasPersonalization
      ? 'pair_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 8)
      : null;
    // Main jersey: show "Personalization: <text>" — the essential info. _pair is the only internal flag we need.
    var items = [{
      id: mainId,
      quantity: qty,
      properties: hasPersonalization ? Object.assign({}, mainProps, {
        'Personalization': persVal,
        '_pair': pairId
      }) : mainProps
    }];
    // Personalization add-on: show only "For: <product title>" so staff knows what to print on.
    // _linked_for + _pair are internal flags needed for cart merge/cleanup logic.
    if (hasPersonalization) {
      items.push({
        id: addonId,
        quantity: qty,
        properties: {
          'For': productTitle + ' — ' + persVal,
          '_linked_for': mainId,
          '_pair': pairId
        }
      });
    }

    function postItems(payload) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin',
        body: JSON.stringify(payload)
      }).then(function (r) { return r.json().then(function (data) { return { ok: r.ok, status: r.status, data: data }; }); });
    }

    postItems({ items: items })
      .then(function (res) {
        // If addon failed (out of stock etc), retry with just the main jersey
        // The personalization name is still saved as a line item property.
        if (!res.ok && items.length > 1) {
          return postItems({ items: [items[0]] }).then(function (retry) {
            if (retry.ok && hasPersonalization) {
              showCartError(form, 'Note saved on order — personalization charge couldn’t be applied (out of stock). Please contact us.');
              setTimeout(function () { var n = form.querySelector('.cart-error'); if (n) n.remove(); }, 6000);
            }
            return retry;
          });
        }
        return res;
      })
      .then(function (res) {
        if (!res.ok) {
          showCartError(form, res.data && res.data.description ? res.data.description : 'Could not add to cart');
          return;
        }
        if (btn) {
          btn.classList.add('is-added');
          setTimeout(function () { btn.classList.remove('is-added'); }, 1800);
        }
        return refreshCart().then(function () {
          var drawer = document.getElementById('CartDrawer');
          if (drawer) setTimeout(function () { openPanel(drawer); }, 280);
        });
      })
      .catch(function () { showCartError(form, 'Network error. Please try again.'); })
      .finally(function () {
        if (btn) btn.classList.remove('is-loading');
        if (btn) btn.removeAttribute('disabled');
      });
  });

  function showCartError(form, message) {
    var existing = form.querySelector('.cart-error');
    if (existing) existing.remove();
    var msg = String(message || '');
    // Suppress Shopify's verbose "already sold out" message — it's an admin-side issue, not customer-facing.
    if (/sold out|out of stock|cannot find variant/i.test(msg)) {
      return;
    }
    var el = document.createElement('p');
    el.className = 'cart-error';
    el.setAttribute('role', 'alert');
    el.textContent = msg;
    form.appendChild(el);
    setTimeout(function () { if (el.parentNode) el.remove(); }, 4000);
  }

  // Quantity change in drawer / cart page (also propagates to linked addons)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    e.preventDefault();
    var key = btn.getAttribute('data-key');
    var delta = btn.getAttribute('data-delta');
    var line = btn.closest('[data-key]');
    var input = line ? line.querySelector('[data-qty-input]') : null;
    var current = input ? parseInt(input.value, 10) : 1;
    var next;
    if (delta === 'remove') next = 0;
    else next = Math.max(0, current + parseInt(delta, 10));

    var linkedKeys = (line && line.getAttribute('data-linked-keys') || '')
      .split(',').map(function (k) { return k.trim(); }).filter(Boolean);

    if (linkedKeys.length) {
      var updates = {};
      updates[key] = next;
      linkedKeys.forEach(function (k) { updates[k] = next; });
      updateLines(updates);
    } else {
      changeLine(key, next);
    }
  });

  function changeLine(key, qty) {
    setLoading(true);
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshCart(); })
      .then(function () {
        if (document.querySelector('.main-cart')) window.location.reload();
      });
  }

  function updateLines(updates) {
    setLoading(true);
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshCart(); })
      .then(function () {
        if (document.querySelector('.main-cart')) window.location.reload();
      });
  }
})();
